export default __webpack_public_path__ + "2ffb4ace2c53584fe22741e0bd26c26a.svg";